"use client";

import { useEffect } from "react";

/**
 * 动态设置浏览器 theme-color，使工具栏颜色与页面背景一致
 * 组件卸载时会自动恢复原来的颜色
 * @param color - 要设置的 theme-color 值
 */
export function useThemeColor(color: string) {
  useEffect(() => {
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    const originalColor = metaThemeColor?.getAttribute("content") || "#ffffff";
    const htmlEl = document.documentElement;
    const bodyEl = document.body;
    const originalHtmlBg = htmlEl.style.getPropertyValue("background");
    const originalHtmlBgPriority = htmlEl.style.getPropertyPriority("background");
    const originalHtmlBgColor = htmlEl.style.getPropertyValue("background-color");
    const originalHtmlBgColorPriority = htmlEl.style.getPropertyPriority("background-color");
    const originalBodyBg = bodyEl.style.getPropertyValue("background");
    const originalBodyBgPriority = bodyEl.style.getPropertyPriority("background");
    const originalBodyBgColor = bodyEl.style.getPropertyValue("background-color");
    const originalBodyBgColorPriority = bodyEl.style.getPropertyPriority("background-color");

    if (metaThemeColor) {
      metaThemeColor.setAttribute("content", color);
    }
    // iOS Safari 底部栏/回弹区域会露出 html/body 背景，这里与页面主题色保持一致。
    htmlEl.style.setProperty("background", color, "important");
    htmlEl.style.setProperty("background-color", color, "important");
    bodyEl.style.setProperty("background", color, "important");
    bodyEl.style.setProperty("background-color", color, "important");

    // 组件卸载时恢复原来的颜色
    return () => {
      if (metaThemeColor) {
        metaThemeColor.setAttribute("content", originalColor);
      }

      if (originalHtmlBg) {
        htmlEl.style.setProperty("background", originalHtmlBg, originalHtmlBgPriority);
      } else {
        htmlEl.style.removeProperty("background");
      }
      if (originalHtmlBgColor) {
        htmlEl.style.setProperty("background-color", originalHtmlBgColor, originalHtmlBgColorPriority);
      } else {
        htmlEl.style.removeProperty("background-color");
      }

      if (originalBodyBg) {
        bodyEl.style.setProperty("background", originalBodyBg, originalBodyBgPriority);
      } else {
        bodyEl.style.removeProperty("background");
      }
      if (originalBodyBgColor) {
        bodyEl.style.setProperty("background-color", originalBodyBgColor, originalBodyBgColorPriority);
      } else {
        bodyEl.style.removeProperty("background-color");
      }
    };
  }, [color]);
}

